import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { io } from 'socket.io-client';
import { useGetSubscriptionPurchasesByShopQuery } from '../features/shop/shopApiSlice';
import { SOCKET_URL } from '../config/axios';

const useMarketerInvoice = (shopid) => {
  const { name } = useSelector((state) => state.user);

  const {
    data,
    isLoading,
    isFetching,
    isError,
    error,
    refetch,
  } = useGetSubscriptionPurchasesByShopQuery(shopid, {
    skip: !shopid,
    refetchOnFocus: true,
    refetchOnReconnect: true,
  });

  useEffect(() => {
    if (!name?._id) return;

    const socket = io(SOCKET_URL);
    socket.emit('join_user', name._id);

    const handleNotification = () => {
      refetch();
    };

    socket.on('notification', handleNotification);

    return () => {
      socket.off('notification', handleNotification);
      socket.disconnect();
    };
  }, [name?._id, refetch]);

  return {
    invoiceData: data?.data,
    isLoading,
    isFetching,
    isError,
    error,
    refetch,
  };
};

export default useMarketerInvoice;
